import { Template } from './types'

export const defaultTemplates: Template[] = [
	{
		id: 'simple-card',
		name: 'Simple Card',
		description: 'A basic card with a title and content. Good for simple announcements.',
		html: `
<div class="card">
  <h1>{{TITLE}}</h1>
  <p>{{CONTENT}}</p>
</div>`,
		css: `
.card {
  border: 1px solid #ddd;
  padding: 16px;
  border-radius: 8px;
  font-family: sans-serif;
  background-color: #f9f9f9;
}`,
		variables: ['{{TITLE}}', '{{CONTENT}}'],
	},
	{
		id: 'complex-article',
		name: 'Complex Article',
		description: 'A full-width article layout with a header, image, and metadata.',
		html: `
<article class="article">
  <header class="article-header">
    <div class="article-category">Technology</div>
    <h1 class="article-title">{{TITLE}}</h1>
    <div class="article-meta">
      <span class="article-date">December 15, 2023</span>
      <span class="article-author">By Sarah Johnson</span>
    </div>
    <p class="article-excerpt">{{metaDescription}}</p>
  </header>
  <div class="article-content">
    {{CONTENT}}
  </div>
  <footer class="article-footer">
    <div class="article-tags">
      <span class="tag">AI Technology</span>
      <span class="tag">Digital Marketing</span>
      <span class="tag">Innovation</span>
    </div>
  </footer>
</article>`,
		css: `
.article {
  max-width: 800px;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  font-family: 'Georgia', 'Times New Roman', serif;
  line-height: 1.6;
  color: #2c3e50;
}

.article-header {
  padding: 32px 40px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
  position: relative;
}

.article-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #ff6b6b, #4ecdc4, #45b7d1);
}

.article-category {
  display: inline-block;
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 16px;
}

.article-title {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 16px 0;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.article-meta {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
  font-size: 14px;
  opacity: 0.9;
}

.article-date,
.article-author {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.article-excerpt {
  font-size: 18px;
  line-height: 1.5;
  margin: 0;
  color: rgba(255, 255, 255, 0.95);
  font-style: italic;
}

.article-content {
  padding: 40px;
  background-color: #ffffff;
  color: #2c3e50;
}

.article-content p {
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 1.7;
  color: #34495e;
  text-align: justify;
}

.article-content p:first-child {
  font-size: 18px;
  font-weight: 500;
  color: #2c3e50;
}

.article-content p:last-child {
  margin-bottom: 0;
}

.article-footer {
  padding: 24px 40px 32px;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.article-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag {
  display: inline-block;
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  border: 1px solid #bbdefb;
  transition: all 0.2s ease;
}

.tag:hover {
  background-color: #bbdefb;
  transform: translateY(-1px);
}

/* Responsive design */
@media (max-width: 768px) {
  .article {
    margin: 0;
    border-radius: 0;
  }
  
  .article-header {
    padding: 24px 20px 20px;
  }
  
  .article-title {
    font-size: 24px;
  }
  
  .article-content {
    padding: 24px 20px;
  }
  
  .article-footer {
    padding: 20px;
  }
  
  .article-meta {
    flex-direction: column;
    gap: 8px;
  }
}`,
		variables: ['{{TITLE}}', '{{CONTENT}}', '{{metaDescription}}'],
	},
]
